import { render, staticRenderFns } from "./birthdaySettingInfo.vue?vue&type=template&id=6f30816c&scoped=true&"
import script from "./birthdaySettingInfo.vue?vue&type=script&lang=js&"
export * from "./birthdaySettingInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f30816c",
  null
  
)

export default component.exports